import { useEffect } from "react";
import { motion } from "framer-motion";
import { useAnswer } from "../../../util/form";

export default function ChooseOwnPortfolio({
  advanceScreen,
  previousScreen,
  updateValidation,
  screen,
}) {
  // We don't need to set an answer in this screen as it would overwrite the portfolio selection
  // from screen 3.14, but we keep the hook for consistency
  useAnswer(screen.id);

  useEffect(() => {
    updateAnswer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  function updateAnswer() {
    // Don't set a new answer here - this would overwrite the portfolio selection from screen 3.14
    // Just update validation to allow continuing
    updateValidation(true);
  }

  return (
    <motion.div
      className="w-full h-full"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.35 }}
    >
      <section className="w-full h-full px-6 py-16 text-center bg-white md:px-10 md:py-10 lg:px-16 lg:py-16">
        <div className="flex flex-col md:h-full">
          <div className="mb-10">
            <div className="max-w-xl mx-auto">
              <h1 className="text-base font-bold text-as-green-100 md:text-lg">
                Confirm & Continue
              </h1>
              <h2 className="mt-2 text-3xl mb-4 md:mb-5 md:mt-3 md:text-4xl">
                You have opted to choose your own portfolio
              </h2>
              <p>
                By selecting “Continue,” you acknowledge that the portfolio
                you’ve selected may be too aggressive or too conservative given
                your age, expected retirement date and other information you may
                have provided.
              </p>
              <p>
                If you select a more aggressive portfolio than the recommended
                portfolio, you may expose your retirement account to additional
                risk, including the risk of a significant loss from which your
                portfolio may be less likely to recover prior to your targeted
                retirement date.
              </p>
              <p>
                If you select a more conservative portfolio than the recommended
                portfolio, you may need to save substantially more to reach your
                retirement goals.
              </p>
            </div>
            <div className="flex justify-center gap-3 mt-6 md:mt-10 md:gap-5">
              <button className="btn btn--secondary" onClick={previousScreen}>
                Back
              </button>
              <button className="btn btn--primary" onClick={advanceScreen}>
                Continue
              </button>
            </div>
          </div>
        </div>
      </section>
    </motion.div>
  );
}
